import { CHART_COLORS } from "../utils/chartTheme";

export default function KpiStrip({ kpis = {} }) {
  const items = [
    {
      label: "Ore totale",
      value: kpis.totalHours ?? 0,
      suffix: "h",
      accent: CHART_COLORS.teal,
    },
    {
      label: "Ore OT (19–22 + pas 22)",
      value: kpis.otHours ?? 0,
      suffix: "h",
      accent: CHART_COLORS.yellow,
    },
    {
      label: "Vonesa totale",
      value: kpis.lateHours ?? 0,
      suffix: "h",
      accent: CHART_COLORS.red,
    },
    {
      label: "Ditë pushimi",
      value: kpis.leaveDaysUsed ?? 0,
      suffix: "",
      accent: CHART_COLORS.blue,
    },
  ];

  return (
    <div className="analytics-kpi-strip">
      {items.map((item) => (
        <div
          key={item.label}
          className="analytics-kpi"
          style={{ "--kpi-accent": item.accent }}
        >
          <span className="analytics-kpi__label">{item.label}</span>
          <span className="analytics-kpi__value">
            {item.value}
            {item.suffix ? (
              <span className="analytics-kpi__suffix">{item.suffix}</span>
            ) : null}
          </span>
        </div>
      ))}
    </div>
  );
}
